define('SearchSpring.Search.View', [
	'AjaxRequestsKiller',
	'Backbone',
	'Categories',
	'Facets.Browse.View',
	'LiveOrder.Model',
	'SC.Configuration',
	'SearchSpring.Facets.Helper',
	'SearchSpring.Facets.Model',
	'underscore',
	'Utils'
], function SearchSpringSearchView(
	AjaxRequestsKiller,
	Backbone,
	Categories,
	FacetsBrowseView,
	LiveOrderModel,
	Configuration,
	FacetsSearchSpringHelper,
	FacetsSearchSpringModel,
	_,
	Utils
) {
	var statuses = window.statuses;

	var collapsable_elements = window.collapsable_elements;

	return FacetsBrowseView.extend({
		initialize: function initialize(options) {
			var fullurl = Backbone.history.fragment;
			this.options = options;
			this.application = options.application;
			this.environment = this.application && this.application.getComponent('Environment');
			this.statuses = statuses;

			this.collapsable_elements = collapsable_elements;
			this.translatorConfig = this.application.translatorConfig;
			this.categoriesTopLevelUrl = Categories.getTopLevelCategoriesUrlComponent();
			this.isCategoryPage = false;
			this.model = new FacetsSearchSpringModel();
			this.translator = FacetsSearchSpringHelper.parseUrl(
				fullurl,
				this.translatorConfig,
				this.isCategoryPage
			);
			this.router = this.constructor.router;

			this.setOptionsTranslator();

			this.model.options = {
				data: this.translator.getApiParams(),
				killerId: AjaxRequestsKiller.getKillerId(),
				pageGeneratorPreload: false
			};

			this.itemsDisplayOptions = Utils.deepCopy(
				this.environment.getConfig('itemsDisplayOptions')
			);
			this.resultsPerPage = Utils.deepCopy(this.environment.getConfig('resultsPerPage'));
			this.sortOptions = Utils.deepCopy(this.environment.getConfig('sortOptions'));

			_.each(this.resultsPerPage, function eachResultPerPage(perPage) {
				perPage.id = String(perPage.items);
			});

			this.cart = LiveOrderModel.getInstance();

			this.collapsable_elements['facet-header'] = this.collapsable_elements['facet-header'] || {
				selector: 'this.collapsable_elements["facet-header"]',
				collapsed: false
			};
		}
	});
});
